module.exports = __webpack_public_path__ + "static/media/microverse-capstone-final.2781600b.png";